import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const FooterLegal = () => {
  return (
    <footer
      className="pt-5 pb-4 text-center text-md-start"
      style={{
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid #E7F5F2",
      }}
    >
      <Container>
        <Row className="gy-4">
          <Col md={4}>
            <h5 style={{ color: "#2D8A7A" }}>Majistral App</h5>
            <p className="text-muted small">
              Majistral Formül Veri Tabanı
            </p>
          </Col>

          <Col md={4}>
            <h6 style={{ color: "#2D8A7A" }}>Yasal Bilgiler</h6>
            <ul className="list-unstyled small">
              <li><a href="/yasal-bilgiler" className="text-muted">K.V.K.K</a></li>
              <li><a href="/yasal-bilgiler" className="text-muted">Açık Rıza Metni</a></li>
              <li><a href="/yasal-bilgiler" className="text-muted">Gizlilik Politikası</a></li>
              <li><a href="/yasal-bilgiler" className="text-muted">Mesafeli Satış Sözleşmesi</a></li>
              <li><a href="/yasal-bilgiler" className="text-muted">Çerez Politikası</a></li>
              <li><a href="/yasal-bilgiler" className="text-muted">Üyelik Sözleşmesi</a></li>
              <li><a href="/yasal-bilgiler" className="text-muted">Tıbbi Sorumluluk Reddi</a></li>
            </ul>
          </Col>

          <Col md={4}>
            <h6 style={{ color: "#2D8A7A" }}>İletişim</h6>
            <p className="text-muted small mb-1">
              <FaEnvelope className="me-2" />
              info@majistralapp.com
            </p>
            <p className="text-muted small mb-1">
              <FaPhoneAlt className="me-2" />
              +90 (500) 000 00 00
            </p>
            <a
              href="https://instagram.com/majistralapp"
              className="text-muted small d-inline-flex align-items-center"
            >
              <FaInstagram className="me-2" /> Instagram
            </a>
          </Col>
        </Row>

        <hr className="my-4" />

        <div className="text-center small text-muted">
          Esculife Health, {new Date().getFullYear()} | Tüm hakları saklıdır.
        </div>
      </Container>
    </footer>
  );
};

export default FooterLegal;